/**
 * マニュアルページ専用i18n定数
 */

export const MANUAL_I18N = {
  toolbar: {
    title: $localize`:@@home.manual.toolbar.title:マニュアル`,
  },
  subtitle: $localize`:@@home.manual.subtitle.main:取扱説明書のダウンロード、およびシステム共通の「よくある質問」のページです。`,
} as const;

export type ManualI18n = typeof MANUAL_I18N;
